export const MAX_RATING = 5;
export const STAR_STEP = 0.5;

const countFormatter = new Intl.NumberFormat('en-US');

export const formatCount = (count: number): string =>
  countFormatter.format(count);

export const normalizeScore = (score: number): number => {
  if (!Number.isFinite(score)) return 0;
  const snapped = Math.round(score / STAR_STEP) * STAR_STEP;
  return Math.min(MAX_RATING, Math.max(0, snapped));
};

export const getStarFill = (score: number, index: number): number => {
  const remainder = score - index;
  return Math.min(Math.max(remainder, 0), 1) * 100;
};
